import React, { useContext, useEffect, useState } from "react";
//Import Context
import { AppContext } from "../../contexts/AppContext";
import staticData from '../../contexts/staticData.json';
//Import Helpers
import { formatCurrency, formatDate, formatDisplayName, getSubventionNames } from "../../shared/helpers";
//Import CSS
import './viewPaymentRequestForm.css';

function ViewPaymentRequestForm({ onClose, requestDetails, establishmentList, fromRequestTracking, fromViewPayment }) {
    const { pmeList, requestsList } = useContext(AppContext);
    const { request, activity } = requestDetails;
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Activar la animación después de que el componente se monte
        setTimeout(() => setIsVisible(true), 50);
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        // Esperar a que termine la animación antes de cerrar
        setTimeout(onClose, 300);
    };

    const getEstablishment = () => {
        return establishmentList.find(establishment => establishment.id === request?.idEstablishment);
    };

    const getPME = () => {
        return pmeList.find(pme => pme.id === request?.idPME);
    };

    const getRequestOrigin = () => {
        if (request?.typeOfRequest === 'payment') {
            const originalRequest = requestsList.find(req => req.id === request.originRequestId);
            return originalRequest;
        }
    };
    return (
        <section className={`view-purchase-request-container payment flex ${isVisible ? 'show' : ''} ${fromRequestTracking ? 'request-tracking' : ''} `}>
            <header className='header-view-purchase-request flex'>
                <h3>Formulario Solicitud de Pago</h3>
                <button className='button-close' onClick={handleClose}><p>Volver</p></button>
            </header>
            <article className='info-request flex'>
                <table className='table-info-request'>
                    <thead>
                        <tr>
                            {/* <th>Folio Solicitud</th> */}
                            <th>Fecha Solicitud</th>
                            <th>Establecimiento</th>
                            <th>RBD</th>
                            <th>Año de Gasto PME</th>
                            <th>Tipo de Subvención</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {/* <td>{request.requestDetails?.folio}</td> */}
                            <td>{formatDate(request?.created)}</td>
                            <td>{getEstablishment()?.nameEstablishment}</td>
                            <td>{getEstablishment()?.rbd}</td>
                            <td>{getPME()?.yearPME}</td>
                            <td>{getSubventionNames(activity?.subsidies)}</td>
                        </tr>
                    </tbody>
                </table>
            </article>
            <article className='description-action flex'>
                <p className='subtitle'>Detalles de la Actividad</p>
                <span className='description-action-box flex'>
                    <table>
                        <thead>
                            <tr>
                                <th>Dimensión</th>
                                <th>Nombre Acción</th>
                                <th>Clasificación</th>
                                <th>Cuenta SUPEREDUC</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatDisplayName(activity?.dimension)}</td>
                                <td>{formatDisplayName(activity?.nameOfAction)}</td>
                                <td>{formatDisplayName(activity?.clasificationOfAction)}</td>
                                <td>{getRequestOrigin().requestDetails.supereducAccount ? formatDisplayName(getRequestOrigin().requestDetails?.supereducAccount) : 'No ingresado'}
                                </td>
                                {/* <td>{request.requestDetails.supereducAccount ? formatDisplayName(request.requestDetails?.supereducAccount) : 'No ingresado'}</td> */}
                            </tr>
                        </tbody>
                    </table>
                </span>
            </article>
            <article className='additional-info flex'>
                <p className='subtitle'>Detalles Solicitud</p>
                <span className='additional-info-box flex'>
                    <table>
                        <thead>
                            <tr>
                                <th>Responsable Solicitud</th>
                                <th>Cargo Responsable</th>
                                <th>Enviada a</th>
                                <th>Monto O.C</th>
                                <th>Tipo de Pago</th>
                                <th>Monto Solicitud de Pago</th>
                                {request.paymentType.value === 'partialPayment' && (
                                    <th>Saldo Pendiente a Pagar</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatDisplayName(request.responsibleName)}</td>
                                <td>{formatDisplayName(request.responsiblePosition)}</td>
                                <td>{request.history[0].sentTo}</td>
                                <td>{formatCurrency(request.purchaseOrderAmount)}</td>
                                <td>{request.paymentType.label}</td>
                                <td>{formatCurrency(request.amountToBePaid)}</td>
                                {request.paymentType.value === 'partialPayment' && (
                                    <td>{formatCurrency(request.amountPayable)}</td>
                                )}
                            </tr>
                        </tbody>
                    </table>
                </span>
            </article>
            <Attachments request={request} />
        </section>
    );
};

const AttachmentSection = ({ title, file }) => {
    if (!file || !file.name || !file.url) return null;

    return (
        <span className='backups flex'>
            <p>{title}:</p>
            <ul className='flex'>
                <li>
                    <a href={file.url} target="_blank" rel="noopener noreferrer">
                        {file.name}
                    </a>
                </li>
            </ul>
        </span>
    );
};

const Attachments = ({ request }) => {
    if (!request?.backups || !staticData?.backupTypes) {
        return (
            <article className='attachments flex'>
                <p className='subtitle'>Archivos Adjuntos</p>
                <p className="no-attachments">No hay archivos adjuntos</p>
            </article>
        );
    }

    return (
        <article className='attachments flex'>
            <p className='subtitle'>Archivos Adjuntos</p>
            {Object.entries(staticData.backupTypes).map(([key, title]) => (
                <AttachmentSection 
                    key={key}
                    title={title}
                    file={request.backups[key]}
                />
            ))}
        </article>
    );
};

export default ViewPaymentRequestForm;